import { DRAG_STATE, DOMAINS } from './constants';
import DragState from './constants/DragState';

export function isDragging(state, domainName) {
  return state.getIn([DRAG_STATE, DOMAINS, domainName, 'dragState']) === DragState.DRAGGING;
}

export function selectDomainData(state, domainName) {
  return state.getIn([DRAG_STATE, DOMAINS, domainName]).toJS();
}
